import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { IOrgSeasonWeek } from '../models/IOrgSeasonWeek';
import { IOrg } from '../models/IOrg';
import { ISeason } from '../models/ISeason';
import { IWeek } from '../models/IWeek';
import { AuthService } from '../account/auth.service';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class OrgSeasonWeekService implements OnInit, OnDestroy {

  public org: Subject<IOrg> = new Subject<IOrg>();
  public season: Subject<ISeason> = new Subject<ISeason>();
  public week: Subject<IWeek> = new Subject<IWeek>();
  //public model: IOrgSeasonWeek = { season: null, week: null, org: null };
  public orgs: IOrg[];
  public disabled: boolean = false;
  public error: any;
  public seasons: ISeason[];
  public weeks: IWeek[];

  constructor(private authService: AuthService,
    private baseService: BaseService) {

    this.orgs = this.authService.orgs;

  }

  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    throw new Error("Method not implemented.");
  }
  updateOrg(org: IOrg) {
    this.org.next(org);
    //this.model.org = org
  }

  updateSeason(season: ISeason) {
    this.season.next(season);
    // this.model.season = season;
    // this.getSeasons();
  }

  updateWeek(week: IWeek) {
    if (week.name > 18)
      week.isPlayoff = true;
    else
      week.isPlayoff = false;
    this.week.next(week)
    // this.model.week = week;
    // this.getWeeks();
  }
  getSeasons() {
    return this.baseService.sendHttpGet('/nfl/getseasons');
  }

  // getModel() : Observable<any> {
  //   return this.model;
  // }

  getOrg(): Observable<IOrg> {
    return this.org.asObservable();
  }

  getSeason(): Observable<ISeason> {
    return this.season.asObservable();
  }
  getWeek(): Observable<IWeek> {
    return this.week.asObservable();
  }

  getWeeks(season: ISeason) {
    //var season = {name: this.model.season} as ISeason;
    return this.baseService.sendHttpPost('/nfl/getweeks', season);
  }




}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/orgseasonweek.service.ts